import React, { useState, useImperativeHandle, forwardRef, useEffect, useLayoutEffect, useMemo, useRef } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import Api from '../../../../../_helpers/Api'
import { APIProvider, Map, AdvancedMarker, InfoWindow, useMap } from '@vis.gl/react-google-maps'

//images
import docIcon from '../../../../../assets/img/icons/document.png'
import closeIcon from '../../../../../assets/img/icons/close.png'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import markerImg from '../../../../../assets/img/leeflet/marker-icon.png'

import '../../../../../assets/css/modals/employees.css'
import { Maps } from '../../../../../_config/maps'
import Skeleton from 'react-loading-skeleton'
import Error from '../../../../modals/messages/Error'
import { trans } from '../../../../../_providers/Translation'

let timeout

// Cache for route data
let routeCache = {}

const CENTER = { lat: 42.70060440808085, lng: 23.318481445312504 }

function Employees(props, ref) {

    const history = useHistory()

    const applianceModalRef = useRef(null)
    const workDayModalRef = useRef(null)

    const [state, setState] = useState({
        overlay: false,
        modal: false,
        loading: false,
        data: [],
        partners: [],
        dataLoaded: false,
        selected: null,
        recommendation: null,
        onSave: null
    })

    const [openInfoWindow, setOpenInfoWindow] = useState(null)
    const [flyToBounds, setFlyToBounds] = useState(true)

    useImperativeHandle(ref, () => ({
        open: () => {
            handleOpen()
        },
        close: () => {
            handleClose()
        },
        onSave: fn => {
            setState(prev => ({
                ...prev,
                onSave: fn
            }))
        }
    }))

    useEffect(() => {
        handleSelect(props.selected, props.type, selected => {
            saveSelected(selected)
        })
    }, [props.selected, state.data, state.overlay, state.modal])

    // техници
    useEffect(() => {
        loadData()
    }, [props.params])

    // партньори
    useEffect(() => {
        if (props.canReassign) {
            loadPartners()
        }
    }, [props.params.visit_date, props.canReassign])

    useEffect(() => {
        let employees = state.data
        let partners = state.partners

        let recommendation

        for (let i = 0; i < employees.length; i++) {
            let e = employees[i]

            if (e.reservations_limit_reached === 0) {
                recommendation = e
                break
            }
        }

        if (!recommendation) {
            for (let i = 0; i < partners.length; i++) {
                let e = partners[i]

                if (e.reservations_limit_reached === 0) {
                    recommendation = e
                    break
                }
            }
        }

        setState(prev => ({
            ...prev,
            recommendation: recommendation
        }))

    }, [state.data, state.partners])

    // Fit to all markers when modal opens
    useEffect(() => {
        if (state.overlay && state.modal) {
            setFlyToBounds(true)
        }
    }, [state.overlay, state.modal])

    const loadData = () => {
        setState(prev => ({
            ...prev,
            loading: true,
            dataLoaded: false,
        }))

        let url = 'reservations/employees'

        Api.get(url, {
            params: props.params
        }).then(res => {
            setState(prev => ({
                ...prev,
                data: Array.isArray(res.data) ? res.data : [],
            }))
        }).finally(() => {
            setState(prev => ({
                ...prev,
                loading: false,
                dataLoaded: true
            }))
        })
    }

    const loadPartners = () => {

        let url = 'reservations/partners'

        Api.get(url, {
            params: props.params
        }).then(res => {
            setState(prev => ({
                ...prev,
                partners: res.data,
            }))
        })
    }

    const handleOpen = () => {
        setState(prev => ({
            ...prev,
            overlay: true,
        }))

        setTimeout(() => {
            setState(prev => ({
                ...prev,
                modal: true,
            }))
        }, 50)

    }

    const handleClose = e => {
        if (e) e.preventDefault()

        setState(prev => ({
            ...prev,
            modal: false,
        }))

        setTimeout(() => {
            setState(prev => ({
                ...prev,
                overlay: false,
            }))
        }, 50)
    }

    const handleSelect = (id, type, callback = null) => {

        let stateKey = (type === 'App\\Employee' || type === 'App\\Models\\Employee' || type === 'employee') ? 'data' : 'partners'
        let list = Array.isArray(state[stateKey]) ? state[stateKey] : []
        let selected = list.filter(e => Number(e.id) === Number(id))[0]

        // Fallback: if not found by type, try the other list
        if (!selected) {
            let fallbackKey = stateKey === 'data' ? 'partners' : 'data'
            let fallbackList = Array.isArray(state[fallbackKey]) ? state[fallbackKey] : []
            selected = fallbackList.filter(e => Number(e.id) === Number(id))[0]
        }

        if (!selected) {
            return
        }

        // Open info window for selected employee/partner
        if (type === 'App\\Employee' || type === 'App\\Models\\Employee' || type === 'employee') {
            setOpenInfoWindow(`emp-${id}`)
            setFlyToBounds(`emp-${id}`)
        } else {
            // For partners, just close all popups and focus on reservation
            setOpenInfoWindow('reservation')
            setFlyToBounds('reservation')
        }

        setState(prev => ({
            ...prev,
            selected: selected && selected.id ? selected : null
        }))

        if (typeof callback === 'function') {
            setTimeout(() => {
                callback(selected)
            })
        }
    }

    const handleSave = e => {
        e.preventDefault()

        if (state.selected) {
            if (state.selected.type === 'App\\Employee' || state.selected.type === 'App\\Models\\Employee' || state.selected.type === 'employee') {
                if (!state.selected.can_repair_appliance) {
                    handleClose()

                    let modal = applianceModalRef.current

                    modal.open()
                    modal.onClose(() => {
                        handleOpen()
                    })

                    return
                } else if (!state.selected.in_work_day) {
                    handleClose()

                    let modal = workDayModalRef.current

                    modal.open()
                    modal.onClose(() => {
                        handleOpen()
                    })

                    return
                }
            }
        }

        saveSelected(state.selected)

        handleClose()
    }

    const saveSelected = selected => {
        if (typeof props.onSave === 'function') {
            props.onSave(selected)
        } else if (typeof state.onSave === 'function') {
            state.onSave(selected)
        }
    }

    const getRecommendationName = () => {
        if (state.recommendation.type === 'App\\Partner' || state.recommendation.type === 'App\\Models\\Partner') {
            return state.recommendation.name
        }

        return `${state.recommendation.name} ${state.recommendation.lastname}`
    }

    return (
        <>
            <Error
                ref={applianceModalRef}
                mainMessage={trans('headings.success10')}
                secondaryMessage={trans('subheadings.chooseAnother')}
            />

            <Error
                ref={workDayModalRef}
                mainMessage={trans('messages.selectedEmployeeOnADayOff')}
                secondaryMessage={trans('subheadings.chooseAnother')}
            />

            <div className={`${state.overlay ? 'visible' : ''} overlay`}>

                <div className={`${state.modal ? 'show' : ''} popup-primary`}>
                    <div className='head-new'>
                        <img src={popupDefaultHeadImage} alt="icon" />
                        <div className='texts'>
                            <h2>
                                {trans('headings.chooseContractor')}
                            </h2>
                            <p>{trans('subheadings.chooseContractor')}</p>
                        </div>
                        <span className='close' onClick={handleClose}>

                        </span>
                    </div>

                    {!props.hasPerformer && state.recommendation &&
                        <div className="alert warning">
                            {trans('random.recomendedChoose')} {getRecommendationName()} {trans('random.recomendedChoose2')}
                        </div>
                    }
                    <div id="map-wrapper">
                        <div
                            className="left-new"
                            style={{
                                overflowY: "auto",
                            }}
                        >
                            <div className='top'>
                                <div className='about'>
                                    <b>
                                        {trans('random.basicInfo')}
                                    </b>
                                    <p>{trans('subheadings.basicInfo')}</p>
                                </div>
                            </div>
                            <hr />
                            {state.loading
                                ?
                                <Skeleton
                                    style={{
                                        minHeight: '400px',
                                    }}
                                />
                                : state.data.length === 0
                                    ? <div className="alert warning">{trans('messages.noEmployees')}</div>
                                    : <>
                                        <ul>
                                            {state.data.map(e =>
                                                <li
                                                    key={'e-' + e.id}
                                                    onClick={() => {
                                                        if (state.selected && state.selected.id === e.id && state.selected.type === e.type) {
                                                            setState(prev => ({ ...prev, selected: null }))
                                                            setOpenInfoWindow(null)
                                                            setFlyToBounds(true)
                                                        } else {
                                                            handleSelect(e.id, e.type)
                                                        }
                                                    }}
                                                    className={state.selected && (state.selected.id === e.id && state.selected.type === e.type) ? 'active' : ''}
                                                >
                                                    <div className='top'>
                                                        <div className='left'>
                                                            <b>
                                                                {e.name} {e.lastname}
                                                            </b>
                                                            <p>
                                                                {e.distance > -1 ? `${e.distance.toFixed(2)} km` : trans('random.noGpsData')}
                                                            </p>
                                                        </div>
                                                        {e.type_id === 'EXTERNAL' ?
                                                            <span className='status'>
                                                                {trans('labels.external_tech')}
                                                            </span>
                                                            :
                                                            <>
                                                            </>
                                                        }
                                                    </div>
                                                    {state.selected && (state.selected.id === e.id && state.selected.type === e.type) &&
                                                        <>
                                                            <hr />
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>{trans('random.canRepair')}:</td>
                                                                        <td>{e.can_repair_appliance ? trans('labels.yes') : trans('labels.no')}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>{trans('random.distanceInKM')}:</td>
                                                                        <td>
                                                                            {e.distance > -1
                                                                                ?
                                                                                e.distance.toFixed(2)
                                                                                :
                                                                                '-'
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>{trans('random.freeHour')}:</td>
                                                                        <td>{!e.reservations_limit_reached ? trans('labels.yes') : trans('labels.no')}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <hr />
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>{trans('random.inWorkingTime')}:</td>
                                                                        <td>{e.in_work_time ? trans('labels.yes') : trans('labels.no')}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>{trans('random.canBeFinish')}:</td>
                                                                        <td>{e.can_complete_in_work_time ? trans('labels.yes') : trans('labels.no')}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            {e.has_overlap_reservations ?
                                                                <>
                                                                    <hr />
                                                                    <div style={{ padding: '0 12px' }}>
                                                                        <p style={{ marginBottom: 8, fontWeight: 600 }}>
                                                                            {trans('random.resConflict')}:
                                                                        </p>
                                                                        <ul className="overlaps">
                                                                            {e.overlap_reservations.map((r, i) =>
                                                                                <li key={'o-' + r.id}>
                                                                                    <a href={'/schedule/reservations/edit/' + r.id} target="_blank">
                                                                                        <span>{i + 1}.</span>
                                                                                        <span>{r.reference_code}</span>
                                                                                        <span>{r.full_address}</span>
                                                                                    </a>
                                                                                </li>
                                                                            )}
                                                                        </ul>
                                                                    </div>
                                                                </>
                                                                :
                                                                <>
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </li>
                                            )}
                                        </ul>
                                        {props.canReassign && state.partners.length > 0 &&
                                            <>
                                                <div
                                                    className='top'
                                                    style={{
                                                        marginTop: "40px"
                                                    }}
                                                >
                                                    <div className='about'>
                                                        <b>
                                                            {trans('headings.relationships')}
                                                        </b>
                                                        <p>{trans('subheadings.basicInfo')}</p>
                                                    </div>
                                                </div>
                                                <hr />
                                                <ul>

                                                    {state.partners.map(e =>
                                                        <li
                                                            key={'p-' + e.id}
                                                            onClick={() => {
                                                                if (state.selected && state.selected.id === e.id && state.selected.type === e.type) {
                                                                    setState(prev => ({ ...prev, selected: null }))
                                                                    setOpenInfoWindow(null)
                                                                    setFlyToBounds(true)
                                                                } else {
                                                                    handleSelect(e.id, e.type)
                                                                }
                                                            }}
                                                            className={state.selected && (state.selected.id === e.id && state.selected.type === e.type) ? 'active' : ''}
                                                        >
                                                            <div className='top'>
                                                                <div className='left'>
                                                                    <b>{e.name}</b>
                                                                    <p>{trans('labels.partner')}</p>
                                                                </div>
                                                            </div>
                                                            {state.selected && (state.selected.id === e.id && state.selected.type === e.type) &&
                                                                <>
                                                                    <hr />
                                                                    <table>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>{trans('random.reachedLimit')}:</td>
                                                                                <td>{e.reservations_limit_reached ? trans('labels.yes') : trans('labels.no')}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>{trans('random.leftForDay')}:</td>
                                                                                <td>{!e.max_reservations ? '∞' : e.balance}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </>
                                                            }
                                                        </li>
                                                    )}

                                                </ul>
                                            </>
                                        }
                                    </>
                            }
                        </div>

                        <div className="right">
                            <APIProvider apiKey={Maps.google}>
                                <Map
                                    defaultCenter={CENTER}
                                    defaultZoom={5}
                                    mapId="DEMO_MAP_ID"
                                    style={{ width: '100%', height: '100%' }}
                                    disableDefaultUI={true}
                                    keyboardShortcuts={false}
                                >
                                    <MapContent
                                        employees={state.data}
                                        reservationLat={props.params.lat}
                                        reservationLon={props.params.lon}
                                        openInfoWindow={openInfoWindow}
                                        setOpenInfoWindow={setOpenInfoWindow}
                                        flyToBounds={flyToBounds}
                                        setFlyToBounds={setFlyToBounds}
                                        selected={state.selected}
                                    />
                                </Map>
                            </APIProvider>
                        </div>

                    </div>

                    <div className="footer align-right">
                        <button onClick={handleClose}>
                            {trans('buttons.cancel')}
                        </button>
                        <button className="button-primary" onClick={handleSave}>
                            {trans('buttons.save')}
                        </button>
                    </div>

                </div>
            </div>
        </>
    )
}

// MapContent component handles all map overlays and must be inside <Map> context
function MapContent({ employees, reservationLat, reservationLon, openInfoWindow, setOpenInfoWindow, flyToBounds, setFlyToBounds, selected }) {
    const map = useMap()
    const reservationCircleRef = useRef(null)
    const routePolylinesRef = useRef([])

    const isEmployeeSelected = selected && (
        selected.type === 'App\\Employee' ||
        selected.type === 'App\\Models\\Employee' ||
        selected.type === 'employee'
    )

    const visibleEmployees = useMemo(() => {
        if (isEmployeeSelected) {
            return employees.filter(e => e.id === selected.id)
        }
        return employees
    }, [employees, selected])

    // Create reservation circle marker
    useEffect(() => {
        if (!map || !reservationLat || !reservationLon) return

        if (reservationCircleRef.current) {
            reservationCircleRef.current.setMap(null)
        }

        const circle = new window.google.maps.Circle({
            map,
            center: { lat: parseFloat(reservationLat), lng: parseFloat(reservationLon) },
            radius: 50,
            strokeColor: '#f03',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#f03',
            fillOpacity: 0.5,
        })

        circle.addListener('click', () => setOpenInfoWindow('reservation'))

        reservationCircleRef.current = circle

        return () => {
            if (reservationCircleRef.current) {
                reservationCircleRef.current.setMap(null)
            }
        }
    }, [map, reservationLat, reservationLon])

    // Draw routes from employees to reservation
    useEffect(() => {
        if (!map || !reservationLat || !reservationLon || !visibleEmployees.length) return

        // Clear existing routes
        routePolylinesRef.current.forEach(polyline => polyline.setMap(null))
        routePolylinesRef.current = []

        const directionsService = new window.google.maps.DirectionsService()

        visibleEmployees.forEach(employee => {
            if (!employee.lat || !employee.lon) return

            const origin = { lat: parseFloat(employee.lat), lng: parseFloat(employee.lon) }
            const destination = { lat: parseFloat(reservationLat), lng: parseFloat(reservationLon) }

            const cacheKey = `${origin.lat},${origin.lng}-${destination.lat},${destination.lng}`

            // Check cache first
            if (routeCache[cacheKey]) {
                drawPolyline(routeCache[cacheKey])
                return
            }

            directionsService.route(
                {
                    origin,
                    destination,
                    travelMode: window.google.maps.TravelMode.DRIVING,
                },
                (result, status) => {
                    if (status === 'OK' && result.routes[0]) {
                        routeCache[cacheKey] = result.routes[0].overview_path
                        drawPolyline(result.routes[0].overview_path)
                    }
                }
            )
        })

        function drawPolyline(path) {
            const polyline = new window.google.maps.Polyline({
                path,
                geodesic: true,
                strokeColor: '#2196F3',
                strokeOpacity: 0.7,
                strokeWeight: 4,
                map,
            })
            routePolylinesRef.current.push(polyline)
        }

        return () => {
            routePolylinesRef.current.forEach(polyline => polyline.setMap(null))
            routePolylinesRef.current = []
        }
    }, [map, visibleEmployees, reservationLat, reservationLon])

    // Fit bounds when modal opens or when specific marker is selected
    useEffect(() => {
        if (!map) return

        if (flyToBounds === true) {
            // Fit to all markers initially
            const bounds = new window.google.maps.LatLngBounds()
            let hasMarkers = false

            if (reservationLat && reservationLon) {
                bounds.extend({ lat: parseFloat(reservationLat), lng: parseFloat(reservationLon) })
                hasMarkers = true
            }

            employees.forEach(e => {
                if (e.lat && e.lon) {
                    bounds.extend({ lat: parseFloat(e.lat), lng: parseFloat(e.lon) })
                    hasMarkers = true
                }
            })

            if (hasMarkers) {
                clearTimeout(timeout)
                timeout = setTimeout(() => {
                    map.fitBounds(bounds, { padding: 100 })
                }, 50)
            }
            setFlyToBounds(false)
        } else if (typeof flyToBounds === 'string') {
            // Fit to specific marker and reservation
            const bounds = new window.google.maps.LatLngBounds()

            if (flyToBounds === 'reservation') {
                if (reservationLat && reservationLon) {
                    bounds.extend({ lat: parseFloat(reservationLat), lng: parseFloat(reservationLon) })
                    map.fitBounds(bounds, { padding: 100 })
                }
            } else if (flyToBounds.startsWith('emp-')) {
                const empId = parseInt(flyToBounds.replace('emp-', ''))
                const employee = employees.find(e => e.id === empId)

                if (employee?.lat && employee?.lon) {
                    bounds.extend({ lat: parseFloat(employee.lat), lng: parseFloat(employee.lon) })
                    if (reservationLat && reservationLon) {
                        bounds.extend({ lat: parseFloat(reservationLat), lng: parseFloat(reservationLon) })
                    }
                    clearTimeout(timeout)
                    timeout = setTimeout(() => {
                        map.fitBounds(bounds, { padding: 100 })
                    }, 50)
                }
            }
            setFlyToBounds(false)
        }
    }, [map, flyToBounds, employees, reservationLat, reservationLon])

    // Trigger resize when map becomes visible
    useEffect(() => {
        if (!map) return
        window.google.maps.event.trigger(map, 'resize')
    }, [map])

    return (
        <>
            {/* Reservation circle InfoWindow */}
            {reservationLat && reservationLon && openInfoWindow === 'reservation' && (
                <InfoWindow
                    position={{ lat: parseFloat(reservationLat), lng: parseFloat(reservationLon) }}
                    onCloseClick={() => setOpenInfoWindow(null)}
                >
                    <div>{trans('random.reservationLocation')}</div>
                </InfoWindow>
            )}

            {/* Employee markers */}
            {visibleEmployees.filter(e => e.lat && e.lon).map(e => {
                const key = `emp-${e.id}`
                const pos = { lat: parseFloat(e.lat), lng: parseFloat(e.lon) }

                let popupContent = `${e.name} ${e.lastname}`
                if (e.previous_reservation) {
                    popupContent += `\n${trans('random.expectsReservation')} ${e.previous_reservation.reference_code} ${e.previous_reservation.full_address}`
                }

                return (
                    <React.Fragment key={key}>
                        <AdvancedMarker
                            position={pos}
                            onClick={() => setOpenInfoWindow(openInfoWindow === key ? null : key)}
                        >
                            <img
                                src={markerImg}
                                alt="employee"
                                style={{ width: 25, height: 41 }}
                            />
                        </AdvancedMarker>

                        {openInfoWindow === key && (
                            <InfoWindow
                                position={pos}
                                onCloseClick={() => setOpenInfoWindow(null)}
                                pixelOffset={[0, -41]}
                            >
                                <div style={{ whiteSpace: 'pre-line' }}>
                                    {popupContent}
                                </div>
                            </InfoWindow>
                        )}
                    </React.Fragment>
                )
            })}
        </>
    )
}

export default React.memo(forwardRef(Employees), (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next)
})